import BoltIcon from "@mui/icons-material/Bolt";
import { Button, Tooltip } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { ClientAppEvent } from "../../constants";

import type { SxProps, Theme } from "@mui/material";

import type { QuoteFieldsAudience } from "../QuoteFields";

interface PopulateCustomerRequirementsButtonProps {
  onClick: VoidFunction;
  source: QuoteFieldsAudience;
  enableText?: boolean;
  sx?: SxProps<Theme>;
}

export function PopulateCustomerRequirementsButton(
  props: PopulateCustomerRequirementsButtonProps,
) {
  const { onClick, source, enableText = true, sx = {} } = props;
  const posthog = usePostHog();

  const handleClick = () => {
    // Without `source` this metric would conflate the carrier quote form with the
    // shipper off-platform booking form, which reach the same control.
    posthog?.capture(ClientAppEvent.CUSTOMER_REQUIREMENTS_AUTO_POPULATED, {
      source,
    });
    onClick();
  };

  return (
    <Tooltip title="Auto-fill the pickup, delivery, and equipment with the shipment's requested details.">
      <Button
        aria-label="Auto fill"
        onClick={handleClick}
        variant="outlined"
        sx={sx}
      >
        {enableText ? "Auto Fill" : <BoltIcon />}
      </Button>
    </Tooltip>
  );
}
